import { ReferrerTranslate } from './referrerTranslate.model';

const referrerTranslateEN: ReferrerTranslate = {
  kind: {
    DOULA: 'Doula',
    OBSTETRICIAN: 'Obstetrician',
    NURSE: 'Nurse',
    MATERNITY: 'Maternity hospital',
    OTHER: 'Other',
  },
  combobox: {
    triggerAriaLabel: 'Select referral partner',
    placeholder: 'Referred by',
    searchPlaceholder: 'Search partner...',
    loading: 'Loading partners...',
    empty: 'No partner found',
    clear: 'Remove partner',
    createNew: 'Add new partner',
    createNamed: 'Add "{{name}}"',
    createTitle: 'New referral partner',
    editTitle: 'Edit referral partner',
    editAriaLabel: 'Edit partner {{name}}',
    namePlaceholder: 'Partner name',
    kindPlaceholder: 'Type',
    phonePlaceholder: 'Phone (optional)',
    instagramPlaceholder: 'Instagram (optional)',
    cancel: 'Cancel',
    confirm: 'Add',
    save: 'Save',
    delete: 'Delete',
    confirmDelete: 'Confirm deletion',
  },
  settings: {
    title: 'Referral partners',
    description:
      'Doulas, obstetricians and maternity hospitals who refer clients. The list is ranked by who refers the most.',
    add: 'New partner',
    empty: 'No partner registered yet',
    leadCount: '{{count}} referral(s)',
    actions: {
      edit: 'Edit partner {{name}}',
      delete: 'Delete partner {{name}}',
    },
    delete: {
      title: 'Delete partner',
      text: 'Are you sure you want to delete {{name}}?',
      secondaryText:
        'Referred clients stay registered, but lose the link to this partner.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
  },
  toast: {
    created: 'Partner created successfully',
    updated: 'Partner updated successfully',
    deleted: 'Partner deleted successfully',
    error: {
      create: 'Could not create the partner',
      update: 'Could not update the partner',
      delete: 'Could not delete the partner',
    },
  },
};

export default referrerTranslateEN;
